import React, { useState, useEffect } from 'react';
import styles from './EditEmployment.module.css';
import CurrencyInput from "react-currency-input-field";

// 1. Swap initialData prop to memberData to receive the profile state
const EditEmployment = ({ isOpen, onClose, memberData, onSave }) => {
  const [formData, setFormData] = useState({
    employerName: '',
    staffId: '',
    department: '',
    monthlySalary: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 2. Hydrate the local state fields when modal opens or memberData refreshes
  useEffect(() => {
    if (isOpen && memberData) {
      setFormData({
        employerName: memberData.employer_name || '',
        staffId: memberData.staff_id || '',
        department: memberData.department || '',
        // CurrencyInput gracefully reads strings or numbers; standardizing to string fallback
        monthlySalary: memberData.monthly_salary !== undefined && memberData.monthly_salary !== null 
          ? String(memberData.monthly_salary) 
          : ''
      });
    }
  }, [isOpen, memberData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const payload = {
        employer_name: formData.employerName,
        staff_id: formData.staffId,
        department: formData.department,
        monthly_salary: formData.monthlySalary ? Number(formData.monthlySalary) : null,
      };

      const saved = await onSave(payload);
      if (saved !== false) {
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Edit Employment Information</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formColumn}>
            
            <div className={styles.formGroup}>
              <label htmlFor="employerName">Employer Name <span className={styles.required}>*</span></label>
              <input 
                type="text" 
                id="employerName"
                name="employerName" 
                value={formData.employerName} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="staffId">Staff ID </label>
              <input 
                type="text" 
                id="staffId"
                name="staffId" 
                value={formData.staffId} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="department">Department </label>
              <input 
                type="text" 
                id="department"
                name="department" 
                value={formData.department} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="monthlySalary">Monthly Salary <span className={styles.required}>*</span></label>
              <CurrencyInput
                id="monthlySalary"
                name="monthlySalary"
                className={`form-control ${styles.currencyInput}`}
                placeholder="Enter Amount"
                value={formData.monthlySalary}
                onValueChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    monthlySalary: value || "",
                  }))
                }
                decimalsLimit={2}
                groupSeparator=","
                decimalSeparator="."
                allowDecimals
              />
            </div>

          </div>

          <div className={styles.formActions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={isSubmitting}>Cancel</button>
            <button type="submit" className={styles.saveBtn} disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployment;